export default __webpack_public_path__ + "static/media/target.eac9f3b3.svg";